<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="800">
    <v-form ref="form" class="pt-10 px-11 pb-9 white">
      <v-row>
        <v-col cols="11">
          <p class="gray--text font-weight-bold modal-new-element__title mb-0">
            {{ title }}
          </p>
        </v-col>
        <v-col cols="1" class="text-end">
          <BaseButton text icon @click="closeModal" class="justify-end">
            <v-icon size="17" color="gray" class="justify-end">
              fa-times
            </v-icon>
          </BaseButton>
        </v-col>
        <v-col cols="12" class="pt-8 pb-5">
          <v-switch
            class="pa-0 ma-0 justify-self-center d-inline-block modal-new-element__switch"
            v-model="form.ativo"
            inset
            hide-details
            dense
            color="secondary"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            {{ statusSwitch }} 
          </p>
        </v-col>    
        <v-col cols="12">
          <BaseFormInput
            id-element="nameModality"
            placeholder="Inserir"
            v-model="form.nome"
            required
            :rules="[requiredInput, atLeastThreeCaracters]"
            label-text="Nome"
            validate-on-blur
          />
        </v-col>
        <v-col cols="12" v-if="submodality">
          <BaseFormTextArea
            id-element="tooltipModality"
            placeholder="Inserir"
            v-model="form.tooltip"
            required
            :rules="[requiredInput, maxLengthTextArea]"
            label-text="Texto do tooltip"
            validate-on-blur
          />
        </v-col>
        <v-col cols="12" class="pb-5">
          <p class="body-2 font-weight-bold primary--text mb-2">
            {{ nameTitleImg }} ícone da {{ typeItem }}
          </p>
          <BaseFileInput :item="form.imagem" @update="updateIcon" />
        </v-col>
        <v-col cols="12" class="pb-8" v-if="isEdit && hasHistoric">
          <v-divider />
        </v-col>
        <v-col cols="12" v-if="isEdit && hasHistoric" class="pb-12">
          <p class="gray--text font-weight-bold modal-new-element__title">
            HISTÓRICO DE AÇÕES
          </p>
          <BaseDataTable
            :headers="header"
            :items="list"
            no-data-text="Nenhum Histórico foi encontrado"
            loading-text="Carregando Histórico..."
            hide-default-footer
          >
            <template v-slot:[`item.date`]="{ item }">
              {{ formatHistoricDate(item.date) }}
            </template>
          </BaseDataTable>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="6" sm="4" md="3" lg="2">
          <BaseButton
            v-html="nameButton"
            class="white--text secondary"
            width="100%"
            @click="submit()"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
const tableHeaders = [
  { text: "Data", value: "date", sortable: true },
  { text: "Usuário", value: "name", sortable: true },
  { text: "Status", value: "status.name", sortable: true },
  { text: "Descrição", value: "description", sortable: true }
];
import { requiredInput, maxLengthTextArea } from "@/utils/rules.js";
import { formatHistoricDate } from "@/utils/formats.js";
export default {
  data: () => ({
    requiredInput,
    formatHistoricDate,
    header: tableHeaders,
    maxLengthTextArea,
  }),
  computed: {
    statusSwitch() {
      const status = this.form.ativo ? "Ativo" : "Inativo";
      return `Status ${status}`;
    },
    nameButton() {
      return this.isEdit ? "SALVAR" : "CRIAR";
    },
    nameTitleImg() {
      return this.isEdit ? "Editar" : "Adicionar";
    },
    atLeastThreeCaracters() {
      return (
        (this.form.nome && this.form.nome.length >= 3) ||
        "Deve-se ter pelo menos 3 caracteres"
      );
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit", this.form);
    },
    updateIcon(value) {
      this.form.imagem = value;
    }
  },
  props: {
    title: {
      type: String
    },
    list: {
      type: Array
    },
    hasHistoric: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object
    },
    typeItem: {
      type: String,
      default: "modalidade"
    },
    submodality: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="sass">
.modal-new-element__
  &title
    font-size: 18px
</style>
